export enum ResourceType {
  IMAGE = 'image',
  VIDEO = 'video',
  DOCUMENT = 'document',
  LINK = 'link',
}

export enum ResourceUploadStatus {
  PENDING_UPLOAD = 'PENDING_UPLOAD',
  UPLOADING = 'UPLOADING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
}

export enum TranscodingStatus {
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

interface ResourceStorageRef {
  tag: string;
  filePath: string;
  bucket: string;
}

export interface Resource {
  _id: string;
  type: ResourceType;
  name: string;
  provider: string;
  access: string;
  path: string;
  uploadStatus?: ResourceUploadStatus;
  transcodingStatus?: TranscodingStatus;
  skipTranscoding?: boolean;
  course?: string;
  storageRef?: ResourceStorageRef[];
}
